import { getPermutiveSegments } from '@guardian/commercial-core/permutive';
export const configureBidderSettings = () => {
    window.pbjs.setBidderConfig({
        bidders: ['rubicon'],
        config: {
            ortb2: {
                user: {
                    ext: {
                        data: {
                            permutive: getPermutiveSegments(),
                        },
                    },
                },
            },
        },
    });
    return {
        storageAllowed: true,
    };
};
